import { getApiUrl } from './apiConfig';
import { roundWeight } from './weightConversion';
import {
  clampInt,
  isTimeBasedExercise,
  isHeightBasedExercise,
  isWeightBasedExercise,
  getSetDisplaySeconds,
  getSetDisplayWeight,
} from './sessionExercisePerformance';

function formatSetHistoryToken(setRow, sessionRow, weightInKg) {
  const exercise = sessionRow;
  if (isTimeBasedExercise(exercise)) {
    const sec = getSetDisplaySeconds(setRow, exercise);
    return `(${sec})`;
  }
  if (isWeightBasedExercise(exercise)) {
    const w = getSetDisplayWeight(setRow, weightInKg);
    const unit = weightInKg ? 'kg' : 'lbs';
    return `(${roundWeight(w)}${unit})`;
  }
  if (isHeightBasedExercise(exercise)) {
    const h = setRow.height ?? exercise.height ?? '';
    const label = h != null && String(h).trim() !== '' ? String(h).trim() : '—';
    return `(${label})`;
  }
  const reps = setRow.prescribed_reps ?? exercise.reps ?? '';
  return String(reps);
}

export function formatSessionPerformanceHistoryLine(sessionRow, weightInKg = true) {
  const sets = sessionRow?.performance_sets || [];
  if (sets.length) {
    return sets.map((setRow) => formatSetHistoryToken(setRow, sessionRow, weightInKg)).join(',');
  }
  const setCount = clampInt(sessionRow?.sets, 1);
  const fallbackReps = clampInt(sessionRow?.reps, 1);
  return Array.from({ length: setCount }, () =>
    formatSetHistoryToken({ prescribed_reps: fallbackReps }, sessionRow, weightInKg)
  ).join(',');
}

export async function fetchExercisePerformanceHistory({
  studentId,
  exerciseId,
  limit = 3,
  excludeSessionId = null,
} = {}) {
  if (!studentId || !exerciseId) return [];
  const params = new URLSearchParams({
    student_id: String(studentId),
    exercise_id: String(exerciseId),
    limit: String(limit),
  });
  if (excludeSessionId != null && String(excludeSessionId).trim() !== '') {
    params.set('exclude_session_id', String(excludeSessionId));
  }
  const res = await fetch(
    `${getApiUrl()}/api/training-session-exercises/performance-history?${params.toString()}`
  );
  if (!res.ok) {
    throw new Error('Failed to load exercise history');
  }
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}
